var map = {
	"./AcneIcon.tsx": [
		66915,
		6915
	],
	"./AllergyIcon.tsx": [
		90990,
		990
	],
	"./AmbulanceIcon.tsx": [
		38576,
		8576
	],
	"./AppIcon.tsx": [
		38743,
		8743
	],
	"./AppInvertedIcon.tsx": [
		21772,
		1772
	],
	"./Baby2Icon.tsx": [
		50756,
		756
	],
	"./BabyIcon.tsx": [
		29492,
		7111
	],
	"./BackpainIcon.tsx": [
		19197,
		9197
	],
	"./BandageIcon.tsx": [
		77140,
		7140
	],
	"./BandaidIcon.tsx": [
		18483,
		8483
	],
	"./BirthcontrolIcon.tsx": [
		22554,
		2554
	],
	"./BiteIcon.tsx": [
		81222,
		1222
	],
	"./BloodDropIcon.tsx": [
		49773,
		9773
	],
	"./BloodIcon.tsx": [
		30530,
		530
	],
	"./BurnoutIcon.tsx": [
		14359,
		4359
	],
	"./BusIcon.tsx": [
		27248,
		7248
	],
	"./CalendarIcon.tsx": [
		62182,
		2182
	],
	"./CalmIcon.tsx": [
		77145,
		7145
	],
	"./CancerIcon.tsx": [
		54232,
		4232
	],
	"./CapsuleIcon.tsx": [
		50879,
		879
	],
	"./CategoryIcon.tsx": [
		90460,
		460
	],
	"./CertificateIcon.tsx": [
		23859,
		3859
	],
	"./ChlamydiaIcon.tsx": [
		89274,
		9274
	],
	"./CleanHandIcon.tsx": [
		81150,
		1150
	],
	"./ClinicIcon.tsx": [
		41012,
		1012
	],
	"./ClipboardCheckIcon.tsx": [
		87418,
		7418
	],
	"./ClockIcon.tsx": [
		98116,
		8116
	],
	"./ColdIcon.tsx": [
		69050,
		9050
	],
	"./CoughIcon.tsx": [
		1812,
		1812
	],
	"./CreamIcon.tsx": [
		25260,
		5260
	],
	"./DietIcon.tsx": [
		35578,
		5578
	],
	"./DigestionIcon.tsx": [
		58692,
		8692
	],
	"./DizzyIcon.tsx": [
		62184,
		2184
	],
	"./DoctorIcon.tsx": [
		90489,
		489
	],
	"./DropsIcon.tsx": [
		17024,
		7024
	],
	"./EarIcon.tsx": [
		61366,
		1366
	],
	"./EffervescentIcon.tsx": [
		79736,
		9736
	],
	"./EpipenIcon.tsx": [
		35097,
		5097
	],
	"./FaceIcon.tsx": [
		85115,
		5115
	],
	"./FacemaskIcon.tsx": [
		28555,
		8555
	],
	"./FeetIcon.tsx": [
		19204,
		9204
	],
	"./FeverIcon.tsx": [
		62223,
		4604
	],
	"./FingersIcon.tsx": [
		23992,
		3992
	],
	"./FirstaidIcon.tsx": [
		85116,
		354
	],
	"./GenitalIcon.tsx": [
		48884,
		8884
	],
	"./GynecologyIcon.tsx": [
		10258,
		258
	],
	"./HandIcon.tsx": [
		7387,
		7387
	],
	"./HandicapIcon.tsx": [
		7324,
		7324
	],
	"./HappyIcon.tsx": [
		44112,
		4112
	],
	"./HeadacheIcon.tsx": [
		91875,
		1875
	],
	"./HeartIcon.tsx": [
		28718,
		6337
	],
	"./HerpesIcon.tsx": [
		5231,
		5231
	],
	"./HomeIcon.tsx": [
		76881,
		6881
	],
	"./HormonesIcon.tsx": [
		40019,
		19
	],
	"./InfusionIcon.tsx": [
		68517,
		8517
	],
	"./InhalerIcon.tsx": [
		69583,
		9583
	],
	"./InsectIcon.tsx": [
		86680,
		6680
	],
	"./IntimateIcon.tsx": [
		84507,
		4507
	],
	"./KidneysIcon.tsx": [
		11125,
		1125
	],
	"./LightEmergency.tsx": [
		4960,
		4960
	],
	"./LiverIcon.tsx": [
		6337,
		8718
	],
	"./LungsIcon.tsx": [
		34429,
		4429
	],
	"./LymphIcon.tsx": [
		71128,
		1128
	],
	"./MaleGenitalsIcon.tsx": [
		39594,
		9594
	],
	"./MapIcon.tsx": [
		73264,
		3264
	],
	"./MenopauseIcon.tsx": [
		65421,
		5421
	],
	"./MentalHealthIcon.tsx": [
		46329,
		6329
	],
	"./MetabolismIcon.tsx": [
		73923,
		3923
	],
	"./MigraineIcon.tsx": [
		28156,
		8156
	],
	"./MildEmergencyIcon.tsx": [
		71615,
		1615
	],
	"./MouthIcon.tsx": [
		69275,
		9275
	],
	"./MuscleIcon.tsx": [
		46425,
		6425
	],
	"./NasalSprayIcon.tsx": [
		25108,
		5108
	],
	"./NeurologyIcon.tsx": [
		32824,
		2824
	],
	"./PainIcon.tsx": [
		18100,
		8100
	],
	"./PalmTreeIcon.tsx": [
		49004,
		9004
	],
	"./PancreasIcon.tsx": [
		33015,
		3015
	],
	"./PelvisIcon.tsx": [
		77007,
		7007
	],
	"./PenIcon.tsx": [
		127,
		127
	],
	"./PeriodDelayIcon.tsx": [
		18258,
		8258
	],
	"./PeriodIcon.tsx": [
		16179,
		6179
	],
	"./PhysioTherapistIcon.tsx": [
		85484,
		5484
	],
	"./PhysioTherapy2Icon.tsx": [
		84399,
		4399
	],
	"./PhysioTherapyIcon.tsx": [
		40385,
		385
	],
	"./PillBottleIcon.tsx": [
		62825,
		2825
	],
	"./PregnancyIcon.tsx": [
		75267,
		5267
	],
	"./PrescriptionIcon.tsx": [
		28608,
		8608
	],
	"./PuzzleIcon.tsx": [
		21896,
		1896
	],
	"./SadIcon.tsx": [
		17266,
		7266
	],
	"./SerringeIcon.tsx": [
		79669,
		9669
	],
	"./SexualHealthIcon.tsx": [
		65116,
		5116
	],
	"./ShouldersIcon.tsx": [
		23117,
		3117
	],
	"./SkeletonIcon.tsx": [
		46221,
		6221
	],
	"./SkinIcon.tsx": [
		46299,
		6299
	],
	"./SleepIcon.tsx": [
		22735,
		2735
	],
	"./SleepyEyeIcon.tsx": [
		94947,
		4947
	],
	"./SpraybottleIcon.tsx": [
		7933,
		7933
	],
	"./StomachIcon.tsx": [
		29853,
		9853
	],
	"./StomachVariantIcon.tsx": [
		56474,
		6474
	],
	"./StressIcon.tsx": [
		98728,
		8728
	],
	"./SunCloudIcon.tsx": [
		54881,
		4881
	],
	"./SuppositoryIcon.tsx": [
		56497,
		6497
	],
	"./SweatIcon.tsx": [
		55842,
		5842
	],
	"./TabletsIcon.tsx": [
		16097,
		6097
	],
	"./TasteIcon.tsx": [
		18043,
		8043
	],
	"./TestIcon.tsx": [
		41204,
		1204
	],
	"./TestResultIcon.tsx": [
		50319,
		319
	],
	"./TesttubeIcon.tsx": [
		22130,
		2130
	],
	"./ThroatIcon.tsx": [
		91882,
		1882
	],
	"./TongueIcon.tsx": [
		21124,
		1124
	],
	"./TummyAcheIcon.tsx": [
		74951,
		4951
	],
	"./UrinalInfectionIcon.tsx": [
		51428,
		1428
	],
	"./UrineIcon.tsx": [
		76007,
		6007
	],
	"./VaccinationIcon.tsx": [
		20045,
		45
	],
	"./VisionIcon.tsx": [
		55188,
		5188
	],
	"./WaitingRoomIcon.tsx": [
		82266,
		2266
	],
	"./WaterIcon.tsx": [
		84083,
		4083
	],
	"./WormIcon.tsx": [
		91885,
		1885
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64612;
module.exports = webpackAsyncContext;